import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { BtnForm } from '../../general/BotonesAccion';
import AppBarModal from '../../general/AppBarModal';
import { consulta } from '../../../global/js/funciones';
import TareasTerminadas from '../../general/TareasTerminadas';
import CustomDropzone from '../../general/CustomDropzone';
import emma_w from '../../../global/imagenes/emma_w.png';
import { MenuGestionar } from './MatriculasMenu';
import { formulario, obtenerValores } from '../../../global/js/funciones';
import {
	Checkbox,
	DialogActions,
	Dialog,
	DialogContent,
	FormControl,
	Grid,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	Typography,
	TextField,
	InputLabel,
	MenuItem,
	Select,
	FormControlLabel,
} from '@material-ui/core';
import { CONDICION_FINAN_GRADO, ESTADOS_ID, FECHASGRADO, TIPOS_EXONERACION } from './helper';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		backgroundColor: theme.palette.background.paper
	}
}));

const obtenerActivosActualizacion = (estudiante_id) => {
	
	return new Promise((resolve) => {
		consulta(
			`api/v1.0/matricula/solicitudactiva/${estudiante_id}`,
			null,
			null,
			(error, estado, resp) => {
				resolve(resp);
			},
		);
	});
};

const obtenerPagoCertificados = (num_identificacion) => {
	
  return new Promise((resolve) => {
    consulta(
      `api/v1.0/matriculas/pagocertificados?num_identificacion=${num_identificacion}`,
      null,
      null,
      (error, estado, resp) => {
        resolve(resp);
      }
    );
  });
};


function RenderEstados({ estados_siguiente, solicitudActiva, certificado, estado, cambiarSeleccion, matricula }) {
	const classes = useStyles();
    const certificadogenerado = estados_siguiente.some (({ secundario }) => secundario.codigo === 'Mat_cer_val_soli');
	
	return (
		<>
		{/* {matricula?.tipo?.codigo === 'Mat_Pro_Certi' && matricula.estado_solicitud.codigo == "Mat_cer_val_soli" && !certificado && (
		<Typography variant="subtitle2" style={{ padding: '10px 0' }}>
			No se han encontrado datos de pago para el estudiante. Por favor verifique que el estudiante tenga un pago registrado en SICUC.
		</Typography>
			)}		 */}
		{matricula?.tipo?.codigo === 'Mat_Pro_Certi' && matricula.estado_solicitud.codigo == 'Mat_Env' && solicitudActiva && (
		<Typography variant="subtitle2" style={{ padding: '10px 0' }}>
			El estudiante cuenta con una solicitud de actualización de datos activa. Antes de continuar con este proceso por favor <strong>"Realizar actualización"</strong>
		</Typography>
		)}
		
		<List className={classes.root} subheader={<ListSubheader component="div">Seleccione Estado</ListSubheader>}>
			{estados_siguiente.length >=1 && estados_siguiente.map(({ secundario }) => {
				let { codigo, nombre } = secundario;
				return (
					<ListItem 
						key={codigo} 
						role={undefined} 
						dense 
						button 
						onClick={() => cambiarSeleccion(codigo)}
						disabled={(matricula?.tipo?.codigo === 'Mat_Pro_Certi' && matricula.estado_solicitud.codigo == 'Mat_Env' && solicitudActiva )}
					>
						<ListItemIcon>
							<Checkbox edge="start" checked={estado === codigo} tabIndex={-1} disableRipple />
						</ListItemIcon>
						<ListItemText id={codigo} primary={nombre.toUpperCase()} />
					</ListItem>
				);
			})}
		</List>
		</>
	);
}
const obtenerEstadosProceso = (id, idMatricula, filtros = []) => {
	let f = '';
	filtros.map(({ llave, valor }) => (f = `${f}&${llave}=${valor}`));
	return new Promise((resolve) => {
		consulta(
			`api/v1.0/matriculas/estados/${idMatricula}/${id}?${f}`,
			null,
			null,
			(error, estado, resp) => {
				resolve(resp);
			},
		);
	});
};

class MatriculasGestionar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cargando: true,
			titulo_res: 'Cargando..',
			estado: '',
			motivo: '',
			motivos: false,
			estados_siguiente: [],
			archivos: [],
			seleccion: 'gestion',
			fechasGrado: [],
			tiposExoneracion: [],
			fechaGrado: '',
			tipoExoneracion: '',
			link: '',
			tiposCondicionesGrados: [],
			tipoCondicionGrado: '',
			mensajeCondicionGrado: '',
			solicitudActiva: false,
			certificado: false,
			ref_pag: ''
		};
	}

	async componentDidUpdate({ open }, { estado }) {
		let { open: modalGestionarMatricula, matricula } = this.props;
		let { estado: estadoNew } = this.state;
		if (estadoNew !== estado)
			this.setState({ motivos: true, motivo: '', cargando: false, tipoCondicionGrado: '', mensaje: '' });

		if (open !== modalGestionarMatricula) {
			if (modalGestionarMatricula) {
				this.reiniciarEstado();
				let estados_siguiente = await obtenerEstadosProceso(matricula.tipo.id, matricula.id, [
					{ llave: 'principal', valor: matricula.estado_solicitud.id },
					{ llave: 'secundario__generica', valor: ESTADOS_ID }
				]);

				if (matricula.tipo.codigo == 'Mat_Pro_Cor_Nota_E' && matricula.estado_solicitud.codigo == 'Mat_Env') {
					let codigosAExcluir = ["Mat_Pro", "Mat_Ter"];

					estados_siguiente = estados_siguiente.filter(item => {
						return !codigosAExcluir.includes(item.secundario?.codigo);
					});
				}
				this.setState({ estado: '', mensaje: '', estados_siguiente, cargando: false });
				obtenerValores(FECHASGRADO).then((data) => {
					this.setState({ fechasGrado: data });
				});
				obtenerValores(TIPOS_EXONERACION).then((data) => {
					this.setState({ tiposExoneracion: data });
				});
				obtenerValores(CONDICION_FINAN_GRADO).then((data) => {
					this.setState({tiposCondicionesGrados:data});
				});

				if (matricula.tipo.codigo === 'Mat_Pro_Certi') {
					if (matricula.estado_solicitud.codigo == 'Mat_Env') {
						let solicitudActiva = await obtenerActivosActualizacion(matricula.usuario_registro.id);
						this.setState({ solicitudActiva: solicitudActiva?.tiene_solicitud_activa ?? false });
					} 
					// else if (matricula.estado_solicitud.codigo == 'Mat_cer_val_soli') {
					// 	let certificado = await obtenerPagoCertificados(matricula.usuario_registro.identificacion);
					// 	const estadoPago = certificado.estado_pago === true;
					// 	this.setState({ certificado: estadoPago });
					// }
				}

				this.setState({ estado: '', mensaje: '', estados_siguiente, cargando: false });

			}
		}

	}

	reiniciarEstado() {
		this.setState({
			cargando: true,
			titulo_res: 'Cargando..',
			estado: '',
			estados_siguiente: [],
			archivos: [],
			seleccion: 'gestion', 
			tipoExoneracion: '',
			tiposCondicionesGrados: [],
			tipoCondicionGrado: '',
			mensajeCondicionGrado: '',
			ref_pag: ''
		});
	}

	onChange = ({ target }) => {
		let { value, name } = target;
		this.setState({
			[name]: value
		});
	};

	onSubmit = async () => {
		const { matricula, gestionarMatricula, cambiarEstado, actualizarMensaje } = this.props;
		const { estado, archivos, motivo, fechaGrado, tipoExoneracion, tiposExoneracion, link, tipoCondicionGrado, mensaje, ref_pag } = this.state;
		let sw = true;
		let data = { motivo: '', estado, archivos, link, ref_pag };
		let codExoneracion = '';
		if (motivo) data.motivo = motivo;
		if (fechaGrado) data.fechaGrado = fechaGrado; 
		if (tipoCondicionGrado) {
			data.tipoCondicionGrado = tipoCondicionGrado;
			data.mensajeCondicionGrado = mensaje;
		}
		if (tipoExoneracion){
			data.tipoExoneracion = tipoExoneracion; 
			let found = tiposExoneracion.find(element => element.id == tipoExoneracion);
			let { codigo } = found;
			codExoneracion = codigo;
		}
		if (((matricula.tipo.codigo === 'Mat_Pro_Sol_Rein_Tran' && ( estado === 'Mat_Rein_Tran_Apr_Fac' )) || 
			(matricula.tipo.codigo === 'Mat_Pro_Sol_Gra' && (estado === 'Mat_Ter' ||  estado === 'Mat_Pro_Ter_Exo' || 
			(estado === 'Mat_Pro_Ter_Exo' && codExoneracion == 'Mat_Exo_Reg_Est')))) && archivos.length <= 0 && !(matricula.tipo.codigo === 'Mat_Pro_Sol_Gra' && 
			(matricula.estado_solicitud.codigo === 'Mat_Pro' || matricula.estado_solicitud.codigo === 'Mat_Pro_Sol_Cam_Fec'))) {
			sw = false;
			if(matricula.tipo.codigo === 'Mat_Pro_Sol_Rein_Tran' && estado === 'Mat_Rein_Tran_Apr_Fac') actualizarMensaje({ titulo: 'Por favor adjunte el documento de estudio de homologación', tipo: 'info', mostrar: true, tiempo: 6000 });
			else actualizarMensaje({ titulo: 'Por favor adjunte el Volante de pago', tipo: 'info', mostrar: true, tiempo: 6000 });
		}

		if (sw) {
			cambiarEstado({ render: false })
			this.setState({ cargando: true, titulo_res: 'Enviando..' });
			console.log('Eviando gestión al servidor')
			let {resp, estado } = await gestionarMatricula(matricula.id, data);
			if (estado === 200) {
				if (archivos.length) await this.cargarArchivos(matricula.id, archivos);
			}
			// if ((estado === 'Mat_Ter' || estado === 'Mat_Pro' || estado === 'Mat_Rein_Tran_Apr_Fac' || estado === 'Mat_Pro_Ter_Exo') && archivos.length) await this.cargarArchivos(matricula.id, archivos);	
			this.setState({ cargando: false, titulo_res: 'Cargando..' });
			cambiarEstado({ render: true })
		}
		this.setState({tipoExoneracion: ''});
	}

	cargarArchivos(id, archivos) {
		let { actualizarMensaje } = this.props;
		if (archivos.length === 0) return true;
		const data = new FormData();
		data.append(`total`, archivos.length);
		archivos.map((file, index) => data.append(`archivo${index}`, file));
		formulario(`api/v1.0/matriculas/${id}/adjuntar`, data, 'post', (error, estado, resp) => {
			if (error) {
				const title = 'Ha ocurrido un error al adjuntar los archivos, contacte con el administrador.';
				const icon = 'error';
				actualizarMensaje({ titulo: title, tipo: icon, mostrar: true, tiempo: 6000 });
			}
		});
	}

	handleTipoCondicionGradoChange = (e) => {
		const nuevo = e.target.value;
		const { matricula } = this.props;
		const { tiposCondicionesGrados } = this.state;

		const fechaGradoNombre = matricula?.fecha_solicitud_grado?.fechaGrado?.nombre ?? '—';

		const opcion = tiposCondicionesGrados.find((op) => op.id === nuevo);

		const plantilla = opcion?.valorc ?? '';

		const mensaje = plantilla.replace('{{FECHA}}', fechaGradoNombre);
		
		this.setState({
		tipoCondicionGrado: nuevo, mensaje });
  };

	pintarEstados() {
		let { estado,  estados_siguiente, motivo, fechaGrado, fechasGrado, tiposExoneracion, tipoExoneracion, link, tipoCondicionGrado, tiposCondicionesGrados, mensaje, ref_pag } = this.state;
		
		const { matricula } = this.props;

		const showCondicionGrado = matricula && matricula.tipo.codigo === 'Mat_Pro_Sol_Gra' && estado === 'Mat_Ter' && (matricula.estado_solicitud.codigo === 'Mat_Pro' || matricula.estado_solicitud.codigo === 'Mat_Pro_Sol_Cam_Fec');

		return (
			<Grid container>
				<Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
					<RenderEstados
						cambiarSeleccion={(estado) => this.setState({ estado })}
						estado={estado}
						estados_siguiente={estados_siguiente}
						matricula={matricula}
						solicitudActiva={this.state.solicitudActiva}
						certificado={this.state.certificado}
					/>
				</Grid>
				{estado && ((estado == "Mat_Pro" && matricula.tipo.codigo === 'Mat_Pro_Sol_Rein_Tran') || (estado == "Mat_cer_val_soli" && matricula.tipo.codigo === 'Mat_Pro_Certi'))  && (
					<Grid item xs={12} md={12} style={{'marginBottom': '10px'}}>
						<FormControl className="form-control" >
							<TextField
								value={ref_pag}
								id="ref_pag"
								label={"Referencia de pago"}
								name="ref_pag"
								placeholder={"Digite el numero de Referencia de Pago"}
								type={"number"}
								onChange={this.onChange}
							/>
						</FormControl>
					</Grid>
				)}

				{estado && estado !== "Mat_Pro_Sol_Cam_Fec" && !showCondicionGrado && (
					<Grid item xs={12} md={12}>
						<FormControl className="form-control" >
							<TextField
								value={matricula?.tipo?.codigo === 'Mat_Pro_Certi' && estado === 'Mat_cer_val_soli'? 'Volante de Pago Disponible.': motivo}
								id="txtMotivoRechazo"
								label="Observaciones"
								name="motivo"
								placeholder="Digite observaciones de la solicitud"
								multiline
								onChange={this.onChange}
								disabled={ matricula?.tipo?.codigo == 'Mat_Pro_Certi'&& estado=='Mat_cer_val_soli'}
							/>
						</FormControl>
					</Grid>
				)}
				{ estado === "Mat_Rein_Tran_Est" && (
					<Grid item xs={12} md={12}>
						<FormControl className="form-control" >
							<TextField
								value={link}
								id="txtLink"
								label="Link"
								name="link"
								placeholder="Digite el link"
								multiline
								onChange={this.onChange}
							/>
						</FormControl>
					</Grid>
				)}
				{estado === "Mat_Pro_Sol_Cam_Fec" && (
					<Grid item xs={12} md={12}>
						<FormControl className='form-control'>
							<InputLabel>Fecha de Grado</InputLabel>
							<Select
								value={fechaGrado}
								onChange={(e) => this.setState({ fechaGrado: e.target.value })}
							>
								{
									fechasGrado.map((fg) => (
										<MenuItem key={fg.id} value={fg.id}> {fg.nombre} </MenuItem>
									))
								}
							</Select>
						</FormControl>
					</Grid>
				)}
				{(estado === "Mat_Sol_Gra_Apr_Fac" || estado === 'Mat_Pro_Ter_Exo') && (
					<Grid item xs={12} md={12}>
						<FormControl className='form-control'>
							<InputLabel>Tipo de Exoneración</InputLabel>
							<Select
								value={tipoExoneracion}
								onChange={(e) => this.setState({ tipoExoneracion: e.target.value })}
							>
								{
									tiposExoneracion.map((fg) => (
										<MenuItem key={fg.id} value={fg.id}> {fg.nombre} </MenuItem>
									))
								}
							</Select>
						</FormControl>
					</Grid>
				)}
				{((matricula && matricula.tipo.codigo === 'Mat_Pro_Sol_Gra') && estado === 'Mat_Ter' && (matricula.estado_solicitud.codigo === 'Mat_Pro' || matricula.estado_solicitud.codigo === 'Mat_Pro_Sol_Cam_Fec')) && (
					<Grid item xs={12} md={12} style={{ marginTop: 25 }}>
						<FormControl className='form-control'>
							<InputLabel>Tipo condicion financiera grado</InputLabel>
							<Select
								value={tipoCondicionGrado}
								onChange={this.handleTipoCondicionGradoChange}
							>
								{
									tiposCondicionesGrados.map((fg) => (
										<MenuItem key={fg.id} value={fg.id}> {fg.nombre} </MenuItem>
									))
								}
							</Select>
						</FormControl>
					</Grid>
				)}
				{showCondicionGrado && tipoCondicionGrado && (
					<Grid item xs={12} md={12} style={{ marginTop: 25 }}>
						<FormControl className='form-control'>
							<TextField
							label="Mensaje a enviar"
							multiline
							rows={5}
							fullWidth
							variant="outlined"
							value={mensaje}
							onChange={e => this.setState({ mensaje: e.target.value })}
							/>
						</FormControl>
					</Grid>
				)}
			</Grid>
		);
	}

	eliminarArchivo = (i) => {
		let { archivos } = this.state;
		let { actualizarMensaje } = this.props;
		archivos.splice(i, 1);
		this.setState({ archivos });
		actualizarMensaje({ titulo: `Archivo Retirado.`, tipo: 'success', mostrar: true, tiempo: 6000 });
	};

	agregarArchivos = (arc) => {
		let { archivos } = this.state;
		archivos = archivos.concat(arc);
		this.setState({ archivos });
	};

	pintarAdjuntos() {
		return (
			<CustomDropzone
				archivos={this.state.archivos}
				addFunction={this.agregarArchivos}
				deleteFunction={this.eliminarArchivo}
			/>
		);
	}

	pintar() {
		let { seleccion } = this.state;
		return (
			<div>
				{seleccion === 'gestion' && this.pintarEstados()}
				{seleccion === 'adjuntos' && this.pintarAdjuntos()}
			</div>
		);
	}

	render() {
		let { open, setOpen, matricula } = this.props;
		let { cargando, titulo_res, seleccion } = this.state;
		return (
			<Dialog
				fullWidth={true}
				maxWidth="sm"
				open={open}
				onClose={setOpen.bind(this, false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				className="scroll"
			>
				<AppBarModal
					titulo={'¿ Gestionar Proceso ?'}
					mostrarModal={setOpen}
					titulo_accion="Cerrar"
					accion={() => setOpen(false)}
				/>
				<MenuGestionar
					seleccionar={(seleccion) => this.setState({ seleccion })}
					sele={seleccion}
					matricula={matricula}
				/>
				{
					matricula?.estado_solicitud?.codigo === "Mat_En_Est" && matricula?.tipo?.codigo === "Mat_Pro_Sol_Gra" && (
						<div style={{ 
								backgroundColor: '#e3f2fd', 
								margin: '16px', 
								padding: '12px', 
								borderRadius: '6px',
								color: '#000000',
								fontWeight: '600'
							}}>
							IMPORTANTE: Plazo máximo para visto bueno: <strong>{matricula?.fecha_solicitud_grado?.fechaGrado?.valorc || 'No hay plazo máximo'}</strong>
						</div>
					)
				}
				
				<DialogContent style={{ padding: '1' }} className="scroll">
					{cargando ? (
						<TareasTerminadas mensaje={titulo_res} marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true}/>
					) : (
						<div style={{ padding: '5px 0 5px 0' }}>{this.pintar()}</div>
					)}
				</DialogContent>
				<DialogActions>
					<BtnForm texto="CANCELAR" callback={() => setOpen(false)} />
					{!cargando && <BtnForm texto="ACEPTAR" callback={() => this.onSubmit()} />}
				</DialogActions>
			</Dialog>
		);
	}
}

//Props del componente
MatriculasGestionar.propTypes = {
	//variables
	open: PropTypes.bool.isRequired,
	matricula: PropTypes.object.isRequired,
	//funciones
	setOpen: PropTypes.func.isRequired,
	gestionarMatricula: PropTypes.func.isRequired
};

export default MatriculasGestionar;
